export const glassVertexShader = `
  attribute vec2 uv;
  attribute vec2 position;
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = vec4(position, 0.0, 1.0);
  }
`;

export const glassFragmentShader = `
  precision highp float;

  uniform vec2 uResolution;
  uniform float uHover;
  uniform float uProximity;
  uniform float uTime;
  uniform float uSweep;
  uniform vec3 uColorDark;
  uniform vec3 uColorMid;
  uniform vec3 uColorLight;
  uniform vec3 uSheen;
  uniform vec3 uHoloTint;

  varying vec2 vUv;

  float easeInOut(float x) {
    return x * x * (3.0 - 2.0 * x);
  }

  void main() {
    vec2 res = max(uResolution, vec2(1.0));
    vec2 p = vUv - 0.5;
    p.x *= res.x / res.y;

    float interact = clamp(max(uHover, uProximity * 0.35), 0.0, 1.0);
    float t = uTime * 0.12;

    // Wide, smooth emerald base
    float grad = vUv.x * 0.36 + vUv.y * 0.64;
    float drift = sin(vUv.x * 0.7 + t) * 0.006 + sin(vUv.y * 0.6 - t * 0.5) * 0.005;
    float blend = clamp(grad + drift, 0.0, 1.0);

    vec3 fluid = mix(uColorDark, uColorMid, smoothstep(0.0, 0.78, blend));
    fluid = mix(fluid, uColorLight, smoothstep(0.35, 1.0, blend) * 0.38);

    // Tilted diagonal: top-left → bottom-right
    vec2 tiltDir = normalize(vec2(1.0, 1.0));
    float diagonal = dot(p, tiltDir);

    // Sweep travels along that diagonal, entering top-left and exiting bottom-right
    float eased = easeInOut(clamp(uSweep, 0.0, 1.0));
    float sweepPos = mix(-2.15, 2.15, eased);

    float bandDist = abs(diagonal - sweepPos);
    float band = exp(-pow(bandDist / 0.85, 2.0));

    // Fade band in/out as it enters and leaves the button
    float travelFade = smoothstep(0.02, 0.2, eased) * smoothstep(0.98, 0.8, eased);
    band *= travelFade * interact;

    // Subtle green wash — only slightly lighter than primary
    float holoPhase = sin(diagonal * 2.2 + eased * 3.5 + t) * 0.5 + 0.5;
    vec3 sweepColor = mix(uHoloTint, uSheen, holoPhase * 0.25);

    float wash = band * travelFade * interact;
    fluid = mix(fluid, sweepColor, wash * 0.26);

    float edge = pow(abs(vUv.x - 0.5) * 2.0, 2.0) + pow(abs(vUv.y - 0.5) * 2.0, 2.0);
    fluid *= mix(1.0, 0.76, clamp(edge, 0.0, 1.0));

    gl_FragColor = vec4(fluid, 1.0);
  }
`;
